import { darken } from 'polished';
import styled, { css } from 'styled-components';

import backgroungImg from 'assets/sun-tornado.svg';
import { COLORS } from 'styles/constants';

interface NotVerifiedDisplayProps {
  clickable: boolean;
}

export const Container = styled.div`
  padding: 30px 0;
  width: 100%;
  min-height: 81vh;

  color: #fff;
  background: url(${backgroungImg}) no-repeat center;
  background-size: cover;
  font-size: 2.7vh;

  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;

  > img {
    width: 150px;
    margin-bottom: 25px;

    border: 5px solid ${COLORS.white};
    border-radius: 50%;
  }

  > h4 {
    margin: 20px 10px 0 10px;
    text-align: center;
  }

  > h3 {
    font-size: 2.7vh;
    width: 80%;
    margin: 35px 0;
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  > h3:before,
  > h3:after {
    content: '';
    flex: 1 1;
    border-bottom: 1px solid;
    margin: auto;
  }
  > h3:before {
    margin-right: 10px;
  }
  > h3:after {
    margin-left: 10px;
  }

  @media only screen and (max-width: 700px) {
    > h3 {
      width: 80%;
    }
  }

  @media all and (min-width: 600px) and (max-width: 1200px) {
    > h3 {
      width: 80%;
    }
  }

  @media only screen and (min-width: 1400px) {
    min-height: 86vh;
  }
`;

export const ReputationDisplay = styled.div`
  margin-top: 25px;
  padding: 10px;

  background: #fff;
  color: ${COLORS.primary};
  border-radius: 5px;

  display: flex;
  align-items: center;
`;

export const NotVerifiedDisplay = styled.button<NotVerifiedDisplayProps>`
  margin-top: 25px;
  padding: 15px 20px;

  background: white;
  border: none;
  border-radius: 10px;
  color: red;
  text-decoration: none;
  cursor: auto;

  p {
    font-size: 18px;
    display: flex;
    align-items: center;
  }

  p + p {
    margin-top: 5px;
  }

  span {
    font-size: 22px;
  }

  display: flex;
  flex-direction: column;
  align-items: center;

  ${(props) =>
    props.clickable &&
    css`
      &:hover {
        cursor: pointer;
        background: #eee;
      }
    `}
`;

export const NotVerifiedText = styled.p`
  margin-top: 12px;
  padding: 0 40px;

  font-size: 18px;
  text-align: center;
`;

export const AchievementsContainer = styled.div`
  width: 50%;

  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  flex-wrap: wrap;

  @media only screen and (max-width: 900px) {
    width: 90%;
  }

  @media only screen and (min-width: 1400px) {
    width: 40%;
  }
`;

export const AchievementDisplay = styled.div`
  height: auto;
  min-height: 126px;
  width: 300px;
  padding: 13px 25px;
  margin: 0 5px 25px 5px;

  background: ${COLORS.white};
  border-radius: 5px;
  cursor: pointer;
  color: ${COLORS.darktext};

  display: flex;
  align-items: center;

  > img {
    width: 100px;
  }

  h4 {
    font-size: 25px;
    text-align: center;
  }

  p {
    display: flex;
    align-items: center;
  }

  &:hover {
    background: ${darken(0.08, COLORS.white)};
  }
`;

export const NoAchievementsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  p {
    margin-top: 10px;

    color: ${COLORS.white};
    font-size: 20px;
  }

  @media only screen and (max-width: 900px) {
    padding: 20px;
    text-align: center;
  }
`;
